/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentTypeResponse } from './GetAppointmentTypeResponse';
import {
    GetAppointmentTypeResponseFromJSON,
    GetAppointmentTypeResponseFromJSONTyped,
    GetAppointmentTypeResponseToJSON,
    GetAppointmentTypeResponseToJSONTyped,
} from './GetAppointmentTypeResponse';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentVariantResponse
 */
export interface AppointmentVariantResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof AppointmentVariantResponse
     */
    variantId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentVariantResponse
     */
    participantCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof AppointmentVariantResponse
     */
    duration: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentVariantResponse
     */
    slotIntervalMinutes: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof AppointmentVariantResponse
     */
    price: number;
    /**
     * 
     * @type {PriceType}
     * @memberof AppointmentVariantResponse
     */
    priceType: PriceType;
    /**
     * 
     * @type {number}
     * @memberof AppointmentVariantResponse
     */
    payRate: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentVariantResponse
     */
    onlineMeetingUrl: string | null;
    /**
     * 
     * @type {GetAppointmentTypeResponse}
     * @memberof AppointmentVariantResponse
     */
    appointmentType: GetAppointmentTypeResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentVariantResponse
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the AppointmentVariantResponse interface.
 */
export function instanceOfAppointmentVariantResponse(value: object): value is AppointmentVariantResponse {
    if (!('variantId' in value) || value['variantId'] === undefined) return false;
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('slotIntervalMinutes' in value) || value['slotIntervalMinutes'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('onlineMeetingUrl' in value) || value['onlineMeetingUrl'] === undefined) return false;
    if (!('appointmentType' in value) || value['appointmentType'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function AppointmentVariantResponseFromJSON(json: any): AppointmentVariantResponse {
    return AppointmentVariantResponseFromJSONTyped(json, false);
}

export function AppointmentVariantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentVariantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'variantId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['variantId']),
        'participantCount': ApiUserTasksGetPageParameterFromJSON(json['participantCount']),
        'duration': json['duration'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterFromJSON(json['slotIntervalMinutes']),
        'price': json['price'],
        'priceType': PriceTypeFromJSON(json['priceType']),
        'payRate': json['payRate'],
        'onlineMeetingUrl': json['onlineMeetingUrl'],
        'appointmentType': GetAppointmentTypeResponseFromJSON(json['appointmentType']),
        'isActive': json['isActive'],
    };
}

export function AppointmentVariantResponseToJSON(json: any): AppointmentVariantResponse {
    return AppointmentVariantResponseToJSONTyped(json, false);
}

export function AppointmentVariantResponseToJSONTyped(value?: AppointmentVariantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variantId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['variantId']),
        'participantCount': ApiUserTasksGetPageParameterToJSON(value['participantCount']),
        'duration': value['duration'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterToJSON(value['slotIntervalMinutes']),
        'price': value['price'],
        'priceType': PriceTypeToJSON(value['priceType']),
        'payRate': value['payRate'],
        'onlineMeetingUrl': value['onlineMeetingUrl'],
        'appointmentType': GetAppointmentTypeResponseToJSON(value['appointmentType']),
        'isActive': value['isActive'],
    };
}

